const AVAILABILITY = [
  {
    icon: "/images/brand-logos/zomato.svg",
    title: "Zomato",
    main: false,
  },
  {
    icon: "/images/brand-logos/pb.svg",
    title: "Protein Box",
    main: true,
  },
  {
    icon: "/images/brand-logos/swiggy.svg",
    title: "Swiggy",
    main: false,
  },
];

export default AVAILABILITY;
